<div class="d-flex flex-column gap-3">
  <div class="responsive-card d-flex flex-column gap-4">
    <div class="card-title-container">
      <div class="d-flex flex-column gap-2" [style.max-width.rem]="60">
        <div class="responsive-card-title">{{ cardTitle }}</div>
        <div class="responsive-card-description">
          {{ description }}
        </div>
      </div>
      <app-button [type]="ButtonTypeEnum.primary" (buttonClick)="addRow()" i18n>Add Row</app-button>
    </div>
    <div class="table-container">
      <div class="scrollable-columns">
        <div class="row-header">
          <div class="validation-header"></div>
          <div class="validation-header"></div>
          <div class="column-header" i18n>Last Name</div>
          <div class="column-header" i18n>First Name</div>
          <div class="column-header" i18n>Date of Birth</div>
          <div class="column-header" i18n>SIN</div>
          <div class="column-header" i18n>Email</div>
          <div class="column-header" i18n>Employment Start</div>
          <div class="column-header" i18n>Employment Type</div>
          <div class="column-header" i18n>Province of Employment</div>
          <div class="column-header" i18n>Work from Home</div>
          <div class="column-header" i18n>Contribution Start</div>
          <div class="column-header" i18n>On Leave</div>
          <div class="column-header" i18n>Leave Type</div>
          <div class="column-header" i18n>Leave Start</div>
          <div class="column-header" i18n>Expected Return</div>
        </div>
        <div
          class="row-content"
          (focusout)="onRowBlur($event, i)"
          *ngFor="let row of rows?.controls; let i = index"
          [formGroup]="row">
          <div class="validation-col" ngbDropdown #contributionMenu="ngbDropdown" container="body">
            <div ngbDropdownToggle>
              <button
                [disabled]="rows.controls.length === 1"
                type="button"
                class="no-style-button remove-row-button"
                (click)="contributionMenu.toggle(); $event.stopPropagation()"></button>
            </div>
            <div ngbDropdownMenu>
              <button class="no-style-button delete-button" type="button" ngbDropdownItem (click)="removeRow(i)" i18n>
                Delete Row
              </button>
            </div>
          </div>
          <div class="validation-col">
            <img class="error-icon" *ngIf="rowHasError(i)" [src]="'assets/icons/red/ExclamationCircle.svg'" />
          </div>
          <div class="input-container">
            <app-member-table-text-input
              [error]="row.submitAttempted && row.controls.lastName.invalid"
              controlId="lastName"
              [formControlName]="'lastName'" />
          </div>
          <div class="input-container">
            <app-member-table-text-input
              [error]="row.submitAttempted && row.controls.firstName.invalid"
              controlId="firstName"
              [formControlName]="'firstName'" />
          </div>
          <div class="input-container">
            <app-member-table-date-input
              [error]="row.submitAttempted && row.controls.dateOfBirth.invalid"
              [formControlName]="'dateOfBirth'"
              controlId="dateOfBirth"
              placeholder="dd/mm/yyyy"
              i18n-placeholder />
          </div>
          <div class="input-container">
            <app-member-table-sin-input
              [error]="row.submitAttempted && row.controls.socialInsuranceNumber.invalid"
              [formControlName]="'socialInsuranceNumber'"
              controlId="socialInsuranceNumber" />
          </div>
          <div class="input-container">
            <app-member-table-email-input
              [error]="row.submitAttempted && row.controls.email.invalid"
              controlId="email"
              [formControlName]="'email'" />
          </div>
          <div class="input-container">
            <app-member-table-date-input
              [error]="row.submitAttempted && row.controls.employmentStartDate.invalid"
              [formControlName]="'employmentStartDate'"
              controlId="employmentStartDate"
              placeholder="dd/mm/yyyy"
              i18n-placeholder />
          </div>
          <div class="input-container">
            <app-member-table-typeahead-dropdown
              [error]="row.submitAttempted && row.controls.employmentType.invalid"
              [dropdowns]="employmentTypeDropdowns$ | async"
              [clearable]="false"
              controlId="employmentType"
              [formControlName]="'employmentType'" />
          </div>
          <div class="input-container">
            <app-member-table-typeahead-dropdown
              [error]="row.submitAttempted && row.controls.provinceOfEmployment.invalid"
              [dropdowns]="provinceDropdowns$ | async"
              [clearable]="false"
              controlId="provinceOfEmployment"
              [formControlName]="'provinceOfEmployment'" />
          </div>
          <div class="input-container">
            <app-member-table-typeahead-dropdown
              [error]="row.submitAttempted && row.controls.workFromHome.invalid"
              [dropdowns]="yesNoDropdowns"
              [clearable]="false"
              controlId="workFromHome"
              [formControlName]="'workFromHome'" />
          </div>
          <div class="input-container">
            <app-member-table-date-input
              (valueChanged)="checkContributionStartDate($event, i)"
              [error]="row.submitAttempted && row.controls.contributionStart.invalid"
              [formControlName]="'contributionStart'"
              controlId="contributionStart"
              placeholder="dd/mm/yyyy"
              i18n-placeholder />
          </div>
          <div class="input-container">
            <app-member-table-typeahead-dropdown
              (valueChanged)="onLeaveValueChanged($event, i)"
              [error]="row.submitAttempted && row.controls.onLeave.invalid"
              [dropdowns]="yesNoDropdowns"
              [clearable]="false"
              controlId="onLeave"
              [formControlName]="'onLeave'" />
          </div>
          <div class="input-container">
            <app-member-table-typeahead-dropdown
              [error]="row.submitAttempted && row.controls.leaveType.invalid"
              [dropdowns]="leaveTypeDropdowns$ | async"
              controlId="leaveType"
              [formControlName]="'leaveType'" />
          </div>
          <div class="input-container">
            <app-member-table-date-input
              [error]="row.submitAttempted && row.controls.leaveStartDate.invalid"
              [formControlName]="'leaveStartDate'"
              controlId="leaveStartDate"
              placeholder="dd/mm/yyyy"
              i18n-placeholder />
          </div>
          <div class="input-container">
            <app-member-table-date-input
              [error]="row.submitAttempted && row.controls.leaveExpectedReturnDate.invalid"
              [formControlName]="'leaveExpectedReturnDate'"
              controlId="leaveExpectedReturnDate"
              placeholder="dd/mm/yyyy"
              i18n-placeholder />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-end align-items-center gap-3">
    <app-button [type]="ButtonTypeEnum.secondary" (buttonClick)="cancelClicked.emit()" i18n>Cancel</app-button>
    <app-button
      [type]="ButtonTypeEnum.primary"
      [disabled]="!(allFormsValid$ | async)"
      [loading]="isLoading"
      (buttonClick)="submitTable()">
      {{ primaryButtonText }}
    </app-button>
  </div>
</div>
